// Eigenes Konto: Passwort ändern, Zwei-Faktor-Anmeldung.

import { useState, type FormEvent } from "react";
import { api } from "../api";
import { useAuth } from "../auth/AuthProvider";
import { errorText } from "../components/streaming-ui";
import { Badge, Card, Page, PageHeader } from "../components/ui";
import { ROLE_LABELS, type UserRole } from "@webradiosuite/shared";
import { ZweiFaktorKarte } from "../auth/ZweiFaktorKarte";

export function AccountPage(): JSX.Element {
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", again: "" });
  const [state, setState] = useState<"idle" | "saving" | "saved" | string>("idle");

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    if (form.next !== form.again) return setState("Die beiden neuen Passwörter sind nicht gleich.");
    setState("saving");
    try {
      await api.changePassword(form.current, form.next);
      setForm({ current: "", next: "", again: "" });
      setState("saved");
    } catch (err) {
      setState(errorText(err));
    }
  };
  const input = "input mt-1.5";
  const name = user?.display_name || user?.email?.split("@")[0] || "";
  const kuerzel = name.split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((t) => t[0]).join("").toUpperCase() || "?";
  return (
    <Page>
      <PageHeader title="Mein Konto" description="Dein Zugang zur Suite: Passwort und Zwei-Faktor-Anmeldung." />
      <div className="grid items-start gap-6 lg:grid-cols-[320px_minmax(0,1fr)]">
        {/* Wer man ist – in der Suite und in diesem Radio. */}
        <Card>
          <div className="flex flex-col items-center text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-brand-primary to-brand-primary/60 text-xl font-semibold text-white shadow-glow">
              {kuerzel}
            </span>
            <div className="mt-3 text-base font-semibold text-primary">{name}</div>
            <p className="text-sm text-muted" title={`Rolle ${user?.role ?? ""}`}>{user?.email}</p>
            {user?.role && (
              <Badge tone="brand" className="mt-3">{ROLE_LABELS[user.role as UserRole] ?? user.role}</Badge>
            )}
          </div>
          {user?.tenant_name && (
            <div className="well mt-5 flex items-center justify-between text-sm">
              <span className="text-muted">Radio</span>
              <span className="truncate font-medium text-primary">{user.tenant_name}</span>
            </div>
          )}
        </Card>

        <div className="min-w-0 space-y-6">
        <Card title="Passwort ändern" description="Nach dem Ändern sind andere angemeldete Browser abgemeldet.">
          <form onSubmit={submit} className="max-w-md space-y-4">
            <label className="block text-[0.8rem] font-medium text-secondary">Bisheriges Passwort
              <input type="password" autoComplete="current-password" className={input} value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} required />
            </label>
            <label className="block text-[0.8rem] font-medium text-secondary">Neues Passwort (mindestens 10 Zeichen)
              <input type="password" autoComplete="new-password" minLength={10} className={input} value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} required />
            </label>
            <label className="block text-[0.8rem] font-medium text-secondary">Neues Passwort noch einmal
              <input type="password" autoComplete="new-password" minLength={10} className={input} value={form.again} onChange={(e) => setForm({ ...form, again: e.target.value })} required />
            </label>
            <div className="flex items-center gap-3 pt-1">
              <button type="submit" disabled={state === "saving"} className="btn btn-primary">{state === "saving" ? "Speichere …" : "Passwort ändern"}</button>
            </div>
            {state === "saved" && <div className="callout callout-success">Geändert. Andere angemeldete Browser sind abgemeldet.</div>}
            {state !== "idle" && state !== "saving" && state !== "saved" && <div className="callout callout-danger">{state}</div>}
          </form>
        </Card>
        <ZweiFaktorKarte />
        </div>
      </div>
    </Page>
  );
}
